"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _classnames = _interopRequireDefault(require("classnames"));
var _common = require("../../../core/utils/common");
var _InputWithIcon = require("./InputWithIcon.constants");
require("./InputWithIcon.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var InputWithIcon = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2.default)(InputWithIcon, _PureComponent);
  function InputWithIcon(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      value: ''
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyPress = _this.onKeyPress.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyUp = _this.onKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  var _proto = InputWithIcon.prototype;
  _proto.onChange = function onChange(e) {
    var onChange = this.props.onChange;
    this.setState({
      value: e.target.value
    });
    onChange(e);
  };
  _proto.onBlur = function onBlur(e) {
    var onBlur = this.props.onBlur;
    onBlur(e);
  };
  _proto.onKeyPress = function onKeyPress(e) {
    var onKeyPress = this.props.onKeyPress;
    onKeyPress(e);
  };
  _proto.onKeyUp = function onKeyUp(e) {
    var onKeyUp = this.props.onKeyUp;
    onKeyUp(e);
  };
  _proto.onFocus = function onFocus(e) {
    var onFocus = this.props.onFocus;
    onFocus(e);
  };
  _proto.onSubmit = function onSubmit(e) {
    e.preventDefault();
    var onSubmit = this.props.onSubmit;
    var value = this.state.value;
    onSubmit(value);
  };
  _proto.getType = function getType(elem) {
    var type = this.props.type;
    return elem.classList.contains('toggled') ? 'text' : type;
  };
  _proto.toggleEye = function toggleEye(e) {
    e.preventDefault();
    var parent = e.currentTarget.parentNode;
    var onIcon = parent.querySelector('.showHide-icon');
    var offIcon = parent.querySelector('.showHideOff-icon');
    if (onIcon && offIcon) {
      onIcon.classList.toggle('toggled');
      offIcon.classList.toggle('toggled');
      parent.parentNode.querySelector('input').type = this.getType(offIcon);
    }
  };
  _proto.eyeIcons = function eyeIcons() {
    var _this2 = this;
    var _this$props = this.props,
      type = _this$props.type,
      eyeIcon = _this$props.eyeIcon,
      eyeOffIcon = _this$props.eyeOffIcon;
    return type === 'password' && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactSvg.ReactSVG, (0, _extends2.default)({
      src: eyeIcon,
      className: "showHide-icon toggled"
    }, {
      onMouseDown: function onMouseDown(e) {
        return _this2.toggleEye(e);
      }
    }, {
      wrapper: "span"
    })), _react.default.createElement(_reactSvg.ReactSVG, (0, _extends2.default)({
      src: eyeOffIcon,
      className: "showHideOff-icon"
    }, {
      onMouseDown: function onMouseDown(e) {
        return _this2.toggleEye(e);
      }
    }, {
      wrapper: "span"
    })));
  };
  _proto.renderIconUrl = function renderIconUrl() {
    var _this$props2 = this.props,
      touched = _this$props2.touched,
      valid = _this$props2.valid;
    var successErrorIcon = valid ? _InputWithIcon.successIcon : _InputWithIcon.errorIcon;
    var iconUrl = (0, _common.getTernaryCondition)(touched, successErrorIcon, false);
    var iconClasses = (0, _classnames.default)('icon', {
      'icon-success': touched && valid,
      'icon-error': touched && !valid
    });
    return iconUrl && _react.default.createElement(_reactSvg.ReactSVG, {
      className: iconClasses,
      src: iconUrl,
      wrapper: "span"
    });
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      id = _this$props3.id,
      type = _this$props3.type,
      name = _this$props3.name,
      className = _this$props3.className,
      placeholder = _this$props3.placeholder,
      value = _this$props3.value,
      minLength = _this$props3.minLength,
      maxLength = _this$props3.maxLength,
      readOnly = _this$props3.readOnly,
      disabled = _this$props3.disabled,
      ariaLabel = _this$props3.ariaLabel,
      elementLocator = _this$props3.elementLocator,
      valid = _this$props3.valid,
      touched = _this$props3.touched,
      errorMsg = _this$props3.errorMsg,
      autoComplete = _this$props3.autoComplete;
    var classes = (0, _classnames.default)('atom-input', className, {
      'validation-error': touched && !valid,
      success: touched && valid
    });
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: "input-with-icon",
      id: id
    }, _react.default.createElement("label", {
      htmlFor: id + "_input",
      className: "visually-hidden"
    }, name), _react.default.createElement("input", {
      id: id + "_input",
      type: type,
      name: name,
      className: classes,
      placeholder: placeholder,
      value: type !== 'file' ? value : undefined,
      readOnly: readOnly,
      disabled: disabled,
      "aria-label": ariaLabel,
      "data-locator": elementLocator || "input-" + type + "-" + name,
      minLength: minLength,
      maxLength: maxLength,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyPress: this.onKeyPress,
      onKeyUp: this.onKeyUp,
      onFocus: this.onFocus,
      autoComplete: autoComplete || 'off'
    }), this.renderIconUrl(), this.eyeIcons()), touched && !valid && _react.default.createElement("span", {
      className: "col-sm-12 error-msg",
      "data-locator": elementLocator && elementLocator + "-error" || "input-error-" + type + "-" + name
    }, errorMsg));
  };
  return InputWithIcon;
}(_react.PureComponent);
InputWithIcon.defaultProps = {
  id: '',
  name: '',
  type: 'text',
  className: '',
  placeholder: '',
  value: '',
  minLength: 0,
  maxLength: 999,
  ariaLabel: '',
  readOnly: false,
  disabled: false,
  elementLocator: '',
  touched: false,
  valid: false,
  errorMsg: '',
  autoComplete: 'off',
  onChange: function onChange() {
    /* default onChange handler */
  },
  onBlur: function onBlur() {
    /* default onBlur handler */
  },
  onKeyPress: function onKeyPress() {
    /* default onKeyPress handler */
  },
  onKeyUp: function onKeyUp() {
    /* default onKeyUp handler */
  },
  onFocus: function onFocus() {
    /* default onFocus handler */
  },
  onSubmit: function onSubmit() {
    /* default onSubmit handler */
  }
};
var _default = InputWithIcon;
exports.default = _default;
module.exports = exports["default"];